module.exports = __webpack_public_path__ + "img/pin-alert.3ffeb2c2.svg";